export const enum AuthStep {
  Credentials = 1,
  SecondFactor = 2,
  ChangePassword = 3,
}
